/* global axios */
import ApiClient from './ApiClient';

class PipelineAPI extends ApiClient {
  constructor() {
    super('pipelines', { accountScoped: true });
  }

  createWithDefaults(data) {
    return axios.post(`${this.url}?create_default_stages=true`, data);
  }
}

export default new PipelineAPI();
